import { TablePagination } from "@mui/material";
import { useAppContext } from "AppContext";

const CommonPagination = (props) => {
  const { totalCount, name } = props;

  const {
    state: { commonFilter },
    dispatch,
  } = useAppContext();

  const handlePageChange = (_event, newPage) => {
    dispatch({
      type: "FILTER",
      data: {
        ...commonFilter,
        [name]: {
          ...commonFilter[name],
          page: newPage,
          skip: newPage * commonFilter[name]?.take,
        },
      },
    });
  };

  const handleRowsPerPageChange = (event) => {
    dispatch({
      type: "FILTER",
      data: {
        ...commonFilter,
        [name]: {
          ...commonFilter[name],
          take: event.target.value,
        },
      },
    });
  };

  return (
    <TablePagination
      style={{ flex: "none" }}
      component="div"
      labelRowsPerPage="Rows"
      tabIndex={-1}
      count={totalCount}
      page={commonFilter[name]?.page}
      rowsPerPage={commonFilter[name]?.take}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      rowsPerPageOptions={totalCount > 25 ? [25, 50, 100] : []}
      labelDisplayedRows={({ from, to, count }) => {
        const newForm =
          from > count ? totalCount - commonFilter[name].take + 1 : from;
        return `${newForm}–${to} of ${
          count !== -1 ? count : `more than ${to}`
        }`;
      }}
    />
  );
};

export default CommonPagination;
